import React from 'react'
import { IoIosArrowDropdown, IoIosArrowDropleft, IoIosArrowDropright } from 'react-icons/io';

export const LeftDownIcon = ({show, setShow}) => {
    const selectorToggle = () =>{
        setShow(!show)
    }
const icon = () => {
    const size = 25
    if(!show) return <IoIosArrowDropleft size={size}/>
    return <IoIosArrowDropdown size={size}/>
}
  return (
    <div>
      <div onClick={()=>selectorToggle()}>
      {icon()}
     </div>
    </div>
  )
}
export const LeftRightIcon = ({show, setShow, size = 25}) => {
    const selectorToggle = () =>{
        setShow(!show)
    }
const icon = () => {

    if(!show) return <IoIosArrowDropright size={size}/>
    return <IoIosArrowDropleft size={size}/>
}
  return (
    <div>
      <div onClick={()=>selectorToggle()}>
      {icon()}
     </div>
    </div>
  )
}

